import { Chip } from '@mui/material'
import { ProjectStatusEnum, PROJECT_STATUS_OPTIONS } from '../../consts/projectTypeOptions'
import { normalizeProjectStatus } from '../../pages/Profile/EditProject/Tabs/EditDescriptionForm/helpers/normalizeProjectEnums'
import { COLORS } from '../../styles/variables'

type ChipStyle = { bgcolor: string; color: string; borderColor: string }

/** Прозрачный чип: чёрный текст + яркая обводка по статусу. */
const chipOutline = (borderColor: string): ChipStyle => ({
  bgcolor: 'transparent',
  color: COLORS.BLACK,
  borderColor,
})

const CHIP_COLORS: Record<ProjectStatusEnum, ChipStyle> = {
  [ProjectStatusEnum.DRAFT]: chipOutline(COLORS.LEMON_GRASS),
  [ProjectStatusEnum.ARCHIVED]: chipOutline(COLORS.GRANITE),
  [ProjectStatusEnum.PUBLISHED]: chipOutline(COLORS.STOPLIGHT_GO_GREEN),
  [ProjectStatusEnum.CANCELED]: chipOutline(COLORS.CADMIUM_RED),
  [ProjectStatusEnum.PAUSED]: chipOutline(COLORS.CERULEAN),
  [ProjectStatusEnum.UNPUBLISHED]: chipOutline(COLORS.PROJECT_STATUS_WARNING),
  [ProjectStatusEnum.CLOSED]: chipOutline(COLORS.NICE_BLUE),
}

const CHIP_CONFIG: Record<ProjectStatusEnum, { label: string; sx: ChipStyle }> = PROJECT_STATUS_OPTIONS.reduce(
  (acc, option) => {
    acc[option.value] = {
      label: option.label,
      sx: CHIP_COLORS[option.value],
    }
    return acc
  },
  {} as Record<ProjectStatusEnum, { label: string; sx: ChipStyle }>,
)

type Props = {
  status: string | null | undefined
}

export function ProjectStatusChip({ status }: Props) {
  const key = normalizeProjectStatus(status)
  const config = CHIP_CONFIG[key]

  return (
    <Chip
      size="small"
      label={config.label}
      variant="outlined"
      sx={{
        height: 22,
        fontSize: 11,
        fontWeight: 600,
        flexShrink: 0,
        ...config.sx,
      }}
    />
  )
}
